import React, { useState } from 'react'
import useTranslation from 'hooks/useTranslation';
import { Fields } from 'uicomponents';
import { get } from 'lodash';
import { Field } from 'formik';
import ImportModal from '../importModal';
import { SettingsRow } from '../settings-row';
import { Modal } from "components";

const BasicSettings = ({ values, setFieldValue }) => {
  const { tr } = useTranslation();
  const [importModal, showImportModal] = useState(false);
  return (
    <div>
      <Modal
        size={500}
        backdrop="false"
        isOpen={importModal}
        toggle={() => showImportModal(false)}
      >
        <ImportModal {...{ showImportModal }} />
      </Modal>
      <div>
        <SettingsRow
          title={tr("Начало дня")}
          description={tr(
            "Укажите время или пароль для открытия рабочего дня"
          )}
        >
          <Field
            component={Fields.InputMaskS1}
            name="start_of_the_day"
            placeholder={tr("Введите")}
            mask={"99:99"}
            isRequired={true}
            size={"small"}
          />
        </SettingsRow>

        <SettingsRow
          title={tr("Пароль для удаления продуктов")}
          description={tr(
            "Используется для задания пароля, требуемого при удалении блюд"
          )}
        >
          <Field
            component={Fields.InputS1}
            name="passkey_for_remove_dish"
            type="password"
            placeholder={tr("Введите пароль")}
            isRequired={true}
            size={"small"}
          />
        </SettingsRow>

        <SettingsRow
          title={tr("Пароль при смена агента")}
          description={tr(
            "Используется для задания пароля, требуемого при смене агента"
          )}
        >
          <Field
            component={Fields.InputS1}
            name="passkey_for_change_waiter"
            type="password"
            placeholder={tr("Введите пароль")}
            isRequired={true}
            size={"small"}
          />
        </SettingsRow>

        <SettingsRow
          title={tr("Пароль для возврата товаров")}
          description={tr("Используется для задания пароля, требуемого при возврате товаров")}
        >
          <Field
            component={Fields.InputS1}
            name="passkey_for_return_order_item"
            type="password"
            placeholder={tr("Введите пароль")}
            isRequired={true}
            size={"small"}
          />
        </SettingsRow>

        <SettingsRow
          title={tr("Пароль для восстановления заказа")}
          description={tr(
            "Используется для задания пароля, требуемого при восстановлении заказа"
          )}
        >
          <Field
            component={Fields.InputS1}
            name="passkey_for_return_order"
            type="password"
            placeholder={tr("Введите пароль")}
            isRequired={true}
            size={"small"}
          />
        </SettingsRow>

        <SettingsRow
          title={tr("Импорт данных из внешнего источника")}
          description={tr(
            "Используется для импорта готовых данных из других источников в нашу программу"
          )}
        >
          <button
            type="button"
            onClick={() => showImportModal(true)}
            className={`d-btn d-btn-primary d-btn--small mr-[20px]`}
          >
            {tr("Импорт")}
          </button>
        </SettingsRow>

        <SettingsRow
          title={tr("Цена доставки")}
          description={tr(
            "Сумму, которая будет добавляться к заказу как стоимость доставки"
          )}
        >
          <Field
            component={Fields.InputS1}
            name="delivery_price"
            type="number"
            placeholder={tr("Введите пароль")}
            size={"small"}
            className={"mb-0"}
          />
        </SettingsRow>
      </div>
    </div>
  )
}

export default BasicSettings